module.exports = "/images/Bosnia.png?16daaea7b8b43d3380092df364ce9dd3";